import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';

import { Entity } from './entity.class';

export class Client implements Entity {
	@Required
	@Primary
	id: number;

	title: string;

	company: string;

	@Required
	firstName: string;

	@Required
	lastName: string;

	email: string;

	phoneNumber: string;
	mobileNumber: string;
}